
function isInside(point, el) {
    const { left, right, top, bottom } = el.getBoundingClientRect();
    const { x, y } = point;
    // console.log(left, right, top, bottom, x, y);
    return (left <= x && right >= x) && (top <= y && bottom >= y);
}

class DrawerEl extends HTMLElement {
    constructor() {
        super();

        this.activeEls = this.childNodes;
    }
    
    connectedCallback() {
        this.addEventListener('click', (ev) => {
            const point = {
                x: ev.x,
                y: ev.y
            };
            let isOpen = false;
            this.activeEls.forEach(el => {
                isInside(point, el) ? isOpen = true : null;
            });

            !isOpen ? this.close() : null;
        });
    }

    open() {
        document.querySelector('body').classList.add('drawer-open');
        this.classList.add('drawer-open');
    }

    close() {
        document.querySelector('body').classList.remove('drawer-open');
        this.classList.remove('drawer-open');
    }

}

function debounce(fn, timeout=600) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, timeout);
    }
}
